export default "__VITE_ASSET__DPIolP5m__"